// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  storage: 'https://all-around-player.storage.googleapis.com',
  apiUrl: 'https://phishing-backend-new-e2ad1a72306d.herokuapp.com',
  // apiUrl: 'https://phishing-system-backend-5047f663c8ce.herokuapp.com',
  // apiUrl: 'https://aaplayer.herokuapp.com',
  vznFeathers: {
    apiUrl: 'https://phishing-backend-new-e2ad1a72306d.herokuapp.com',
    // apiUrl: 'https://phishing-system-backend-5047f663c8ce.herokuapp.com',
    // apiUrl: 'https://aaplayer.herokuapp.com',
    loggedOutRoute: 'login',
    authTypes: {
      email: {
        strategy: 'local',
        usernameField: 'email',
        passwordField: 'password',
      },
      phone: {
        strategy: 'mobile',
        usernameField: 'mobile',
        passwordField: 'verificationCode'
      }
    },
    mobileCodeService: 'send-mobile-code'
  },
  hmr: false
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
